<template>
    <form method="post" class="col-lg-5">
        <h3 class="text-primary mb-5"><i class="fas fa-paper-plane mr-3"></i> Send Us a Message</h3>
        <form-group label="Your Name" name="request.name">
            <text-input v-model="request.name" />
        </form-group>
        <form-group label="Email Address" name="request.email">
            <text-input type="email" v-model="request.email" />
        </form-group>
        <form-group label="Phone Number" name="request.phone_number">
            <text-input v-model="request.phone_number" />
        </form-group>
        <form-group label="Your Message" name="request.message">
            <textarea class="form-control" v-model="request.message"></textarea>
        </form-group>
        <submit-button class="btn btn-primary px-5" @click="submit(submitHandler)" :working="working">Send Message</submit-button>
    </form>
</template>

<script>
import FormMethods from 'mixins/FormMethods.vue';
import { required, email } from 'vuelidate/lib/validators';

export default {
    mixins: [
        FormMethods,
    ],
    data: function() {
        return {
            request: {
                name: null,
                email: null,
                phone_number: null,
                message: null
            }
        }
    },
    validations: {
        request: {
            name: { required },
            email: { required, email },
            phone_number: { required },
            message: { required }
        }
    },
    methods: {
        submitHandler: function() {
            axios.post(location.pathname, this.request)
                .then(response => {
                    this.$v.$reset();
                    this.request = {};
                    this.$bus.$emit('alert', 'Message sent');
                })
                .catch(error => {
                    
                })
                .then(_ => this.working = false);
        }
    }
}
</script>